import React, { useEffect, useContext, useState } from "react";
import api from "../../services/api";
import serverHost from "../../services/serverHost";
import AppContext from "../../container/context";

import { Button, CircularProgress, Grid, TextField } from "@mui/material";
import { ShoppingCart } from "@mui/icons-material";

const Produto = ({ match, history }) => {
  const [produtoId] = useState(Number(match.params.id));
  const [carregando, setCarregando] = useState(true);
  const [produto, setProduto] = useState({});
  const [imagem, setImagem] = useState([]);
  const [qtdAdicionar, setQtdAdicionar] = useState(1);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarProduto();
  }, []);

  const carregarProduto = () => {
    api
      .get("produtos/carregarVenda", { id: produtoId })
      .then((produto) => {
        let imagensProduto = [];

        produto.imagens.forEach((imagem) => {
          imagensProduto.push({
            original: `${serverHost()}/${imagem.imagemUrl}`,
            thumbnail: `${serverHost()}/${imagem.imagemUrl}`,
          });
        });

        setImagem(`${serverHost()}/${produto.imagemPrincipal}`);
        setProduto(produto);
        setCarregando(false);
      })
      .catch((e) => {
        if (e.data && e.data.length) {
          if (e.data.includes(1))
            notification(
              "warning",
              "Produto sem compatibilidade com a escola."
            );
        } else {
          notification("error", "Produto inválido.");
        }

        setCarregando(false);
      });
  };

  const adicionarCarrinho = () => {
    if (qtdAdicionar < 1) return notification("warning", "Quantidade inválida");

    const item = {
      produtoId: produto.id,
      valor: produto.valorVenda,
      quantidade: qtdAdicionar,
      grupoDescontoId: produto.grupoDescontoId,
    };

    api
      .post("carrinhos/inserirItem", item)
      .then((res) => {
        notification("success", "Produto adicionado ao carrinho!");
        return history.goBack();
      })
      .catch((err) => {
        const { data } = err.response;
        switch (data[0]) {
          case 1:
            return notification("error", "Usuário inválido");
          case 2:
            return notification("error", "Quantidade inválida");
          case 3:
            return notification("error", "Valor inválido");
          case 4:
            return notification("error", "Produto inválido");
          case 5:
            return notification(
              "error",
              "Produto com venda exclusiva para outra(s) escola(s)"
            );

          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  return (
    <div className="main-container">
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: 15 }}
      >
        <h2>Produto</h2>
        {/* <Button
          variant="contained"
          color="primary"
          startIcon={<ShoppingCart />}
          onClick={() => history.push("/app/carrinho")}
        >
          Meu carrinho
        </Button> */}
      </Grid>

      {carregando ? (
        <CircularProgress />
      ) : produto.id ? (
        <Grid container xs={12}>
          <Grid item md={9}>
            <Grid container style={{ alignItems: "center" }}>
              <Grid item xl={12}>
                <div style={{ marginBottom: 15, marginRight: 15 }}>
                  <TextField
                    className="main-input"
                    fullWidth
                    id="standard-search"
                    label="Quantidade"
                    type="search"
                    value={qtdAdicionar}
                    onChange={(e) => setQtdAdicionar(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12}>
                <div style={{ marginBottom: 15 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginRight: 15 }}
                    onClick={adicionarCarrinho}
                  >
                    Adicionar ao carrinho
                  </Button>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={() => history.goBack()}
                  >
                    Voltar
                  </Button> */}
                </div>
              </Grid>
              <Grid item xl={12}>
                <div style={{ marginBottom: 15 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<ShoppingCart />}
                    onClick={() => history.push("/app/carrinho")}
                  >
                    Meu carrinho
                  </Button>
                </div>
              </Grid>
            </Grid>
            <h3>Produto</h3>
            <p>{produto.nome}</p>
            <br />
            <h3>Categoria</h3>
            <p>{produto.categoriaNome}</p>
            <br />
            <h3>Valor</h3>
            <p>{`R$ ${produto.valorVenda / 100}`}</p>
            <br />

            <h3>Descrição</h3>
            <p>{produto.descricao}</p>
            <br />

            <Grid container>
              <Grid item md={4}>
                <h3>Altura (cm)</h3>
                <p>{produto.altura}</p>
              </Grid>
              <Grid item md={4}>
                <h3>Largura (cm)</h3>
                <p>{produto.largura}</p>
              </Grid>
              <Grid item md={4}>
                <h3>Peso (g)</h3>
                <p>{produto.peso}</p>
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={3}>
            <Grid container>
              <Grid md={4}>
                <img style={{ width: "270px" }} src={imagem} alt="" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <h4>Não foi possível obter os dados do produto.</h4>
      )}
    </div>
  );
};

export default Produto;
